import {
  FETCH_LIST,
  LIST_FETCHED,
  SHOW_INFO_DIALOG,
  HIDE_INFO_DIALOG,
  UPDATED,
  TOGGLE_LOADING,
  SET_ACTIVE_STATE,
  SHOW_MANAGER_EXT_DIALOG,
} from './actionTypes'

export const fetchList = (params, tenantd) => ({
  type: FETCH_LIST,
  payload: {
    tenantd,
    params
  }
})

export const listFetched = result => ({
  type: LIST_FETCHED,
  payload: result
})

export const showInfoDialog = params => ({
  type: SHOW_INFO_DIALOG,
  payload: { params }
})

export const hideInfoDialog = () => ({
  type: HIDE_INFO_DIALOG
})

export const toggleLoading = () => ({
  type: TOGGLE_LOADING
})


export const updated = (id, data) => ({
  type: UPDATED,
  payload: { id, data }
})

export const setActiveState = (id, isActive) => ({
  type: SET_ACTIVE_STATE,
  payload: { id, isActive }
})

export const showManagerExtDialog = params => ({
  type: SHOW_MANAGER_EXT_DIALOG,
  payload: { params }
})
